'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * React hook for listening to a intersection observer on a React ref.
 * Return `intersecting` and `intersectingRatio`;
 *
 * @param options UseIntersectionObserverOptions
 * @return UseIntersectionObserverReturn
 */ const useIntersectionObserver = (options)=>{
    const { intersectionObserverOptions ={
        root: null,
        rootMargin: '0px',
        threshold: 0
    } , ref  } = options;
    const [intersecting, setIntersecting] = React.useState(false);
    const [intersectingRatio, setIntersectingRatio] = React.useState(0);
    const observer = new IntersectionObserver((entries)=>{
        const entry = entries[0];
        if (entry) {
            const { intersectionRatio , isIntersecting  } = entry;
            setIntersecting(isIntersecting);
            setIntersectingRatio(intersectionRatio);
        }
    }, intersectionObserverOptions);
    React.useEffect(()=>{
        if (ref?.current) {
            observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
        return;
    }, [
        ref?.current
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        intersecting,
        intersectingRatio
    };
};

exports.useIntersectionObserver = useIntersectionObserver;
//# sourceMappingURL=use-intersection-observer.js.map
